import { useQuery } from "@tanstack/react-query";
import { ShipmentService } from "src/services/shipments";
import { queryKeys } from "src/constants";
import { ShipmentPaginationOptions } from "src/types";

const useShipments = (shipmentService: ShipmentService, paginationOptions: ShipmentPaginationOptions) => {
  const {
    data: paginatedShipments,
    isLoading,
    isRefetching,
    error: fetchError,
    refetch: refreshShipments
  } = useQuery({
    queryKey: queryKeys.paginatedShipments(paginationOptions),
    queryFn: () => shipmentService.getShipments(paginationOptions)
  });

  return { paginatedShipments, isLoading, isRefetching, fetchError, refreshShipments };
};

export { useShipments };
